import { getFullUrl } from 'hubspot-url-utils';
export const buildHubletUrlOverride = hublet => {
  if (hublet !== 'na1') {
    return url => `${getFullUrl('app-api', {
      hubletOverride: hublet
    })}${url}`;
  }

  return url => url;
};

const getHubletUrl = (subDomainPrefix, hublet) => {
  const overrideConfig = {};

  if (hublet) {
    overrideConfig.hubletOverride = hublet;
  }

  return getFullUrl(subDomainPrefix, overrideConfig);
};

export const getHubletAppUrl = hublet => getHubletUrl('app', hublet);
export const getHubletApiUrl = hublet => getHubletUrl('app-api', hublet);